import React, { useContext, useEffect, useState } from "react";

import { t } from "i18next";
import { TermsContext } from "../../utils/Context";
import { SINGLE, Selector } from "../Selectors/Selector";
import { getEarliestCanvasTerm } from "../TermManagement/utils";

export const EffectiveTermSelect = ({ selectHandler, selectedTermId }) => {
  const { insightsTerms } = useContext(TermsContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    // Filter out past/present terms
    let futureInsightsTerms = [];
    insightsTerms.forEach((insightsTerm) => {
      if (insightsTerm.canvas_terms.length > 0) {
        const earliestCanvasTerm = getEarliestCanvasTerm(insightsTerm);
        if (new Date(earliestCanvasTerm.start_at) > new Date()) {
          futureInsightsTerms.push(insightsTerm);
        }
      }
    });
    futureInsightsTerms = futureInsightsTerms.sort(
      (a, b) => new Date(a.start_at) - new Date(b.start_at)
    );
    setOptions(
      futureInsightsTerms.map((term) => {
        return { ...term, label: term.name };
      })
    );
  }, [insightsTerms]);

  const selectHandlerWrapper = (insightsTermId) => {
    const insightsTerm = options.find((term) => term.id === insightsTermId);
    selectHandler(insightsTerm);
  };

  return (
    <Selector
      type={SINGLE}
      id="effective-term-select"
      label={t("learningOutcomes.effectiveTermOptional")}
      options={options}
      selectHandler={selectHandlerWrapper}
      selectedItemId={selectedTermId}
    />
  );
};
